export default __webpack_public_path__ + "static/media/image_obstruction.0be46f40.svg";